module.exports = __webpack_public_path__ + "img/cliente-2.7f64597f.jpg";